import script from "./ListMelView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListMelView.vue?vue&type=script&setup=true&lang=ts"

import "./ListMelView.vue?vue&type=style&index=0&id=0c9df2fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9df2fa"]])

export default __exports__